module.exports = __webpack_public_path__ + "img/lorixone.4b58243c.svg";